<div class="quick-entity-container">
	<div class="actions-bar">
		<form-field-label [labelTranslateKey]="'create'" />
		<mat-chip-set class="actions-chip-set">
			@for (actionConfig of filteredActionConfigs(); track actionConfig.actionType) {
				<mat-chip-option
					mat-flat-button
					class="action-chip"
					[class.ai-analysis-chip]="actionConfig.actionType === ActionType.AI_ANALYSIS"
					[selected]="currentCard() === actionConfig.actionType"
					(click)="showCard(actionConfig.actionType)"
				>
					<div class="action-chip-content">
						@if (currentCard() !== actionConfig.actionType) {
							<mat-icon [svgIcon]="actionConfig.iconName" />
						}
						{{ actionConfig.translationKey | translate }}
					</div>
				</mat-chip-option>
			}
		</mat-chip-set>
	</div>
	@if (currentCard() !== null && currentCard() !== ActionType.AI_ANALYSIS) {
		@if (loading()) {
			<mat-spinner class="loading-spinner" diameter="40"></mat-spinner>
		} @else {
			<mat-card class="new-quick-entity-card">
				<mat-card-content>
					<entity-edit-title
						[selectedTitle]="entityName()"
						(titleChanged)="entityName.set($event)" />
					<entity-description
						[selectedDescription]="entityDescription()"
						(descriptionChanged)="entityDescription.set($event)"
				/></mat-card-content>

				<mat-card-footer class="quick-entity-footer">
					<div class="quick-entity-chips">
						<mat-icon class="card-icon" [svgIcon]="this.currentCard()"></mat-icon>
						<quick-entity-chips
							[initialChipValue]="entityChipData()"
							(quickChipChanged)="entityChipData.set($event)"
						/>
					</div>

					<div class="quick-entity-actions">
						<button mat-button (click)="resetCard()">
							{{ 'cancel' | translate }}
						</button>
						<button
							mat-flat-button
							color="primary"
							[disabled]="!entityName()"
							(click)="onSave()"
						>
							{{ 'save' | translate }}
						</button>
					</div>
				</mat-card-footer>
			</mat-card>
		}
	}
	@if (
		currentCard() === ActionType.AI_ANALYSIS &&
		featureFlagService.isFFEnabled('aiAssetImageAnalysis')
	) {
		<au-ai-asset-image-analysis-card
			(analysisCompleted)="
				aiAnalysisInput()?.onAnalysisCompleted &&
					aiAnalysisInput().onAnalysisCompleted($event)
			"
			(isLoadingState)="
				aiAnalysisInput()?.onLoadingStateChange &&
					aiAnalysisInput().onLoadingStateChange($event)
			"
			(filesAdded)="
				aiAnalysisInput()?.onFilesAdded && aiAnalysisInput().onFilesAdded($event)
			"
			[existingData]="aiAnalysisInput()?.existingData"
			[attachedFiles]="aiAnalysisInput()?.attachedFiles"
			class="m-b-m"
		/>
	}
</div>
